export function truncateText(el, chars) {
    const text = el.innerText;

    if (text.length > chars) {
        el.innerText = text.substr(0, chars) + '...';
    }
}
